<template>
  <a-layout>
    <!-- head -->
    <global-header/>
    <a-layout-content style="margin-bottom:72px;">
      <page-header :breadcrumb="breadcrumb"></page-header>
      <slot>
        <div class="table-operator">
          <!-- 表格 -->
          <!-- <a-col :span="4"></a-col> -->
          <a-col :span="20" :offset="2">
            <a-tabs defaultActiveKey="2" @change="callback">
              <a-tab-pane tab="报修申请" key="1"></a-tab-pane>
              <a-tab-pane tab="我的报修" key="2" forceRender>
                <standard-table
                  :pagination="PAGINATION"
                  :columns="columns"
                  :dataSource="dataSource"
                  @change="onChange"
                  @rowChange="onRowChange"
                />
              </a-tab-pane>
            </a-tabs>
          </a-col>
          <!-- 查看弹框 -->
          <a-modal
            destroyOnClose
            :maskClosable="false"
            width="800px"
            :title="`报修单明细`"
            v-model="visibleSee"
            :footer="null"
          >
            <a-form>
              <a-form-item
                label="报修单号"
                :labelCol="{span: 4}"
                :wrapperCol="{span: 20}"
              >{{seeinfo.bxdh}}</a-form-item>
              <a-form-item
                label="报修地点"
                :labelCol="{span: 4}"
                :wrapperCol="{span: 20}"
              >{{seeinfo.bxdd}}</a-form-item>
              <a-form-item label="姓名" :labelCol="{span: 4}" :wrapperCol="{span: 20}">{{seeinfo.xm}}</a-form-item>
              <a-form-item label="电话" :labelCol="{span: 4}" :wrapperCol="{span: 20}">{{seeinfo.sjh}}</a-form-item>
              <a-form-item
                label="报修类型"
                :labelCol="{span: 4}"
                :wrapperCol="{span: 20}"
              >{{seeinfo.bxlx}}</a-form-item>
              <a-form-item
                label="故障描述"
                :labelCol="{span: 4}"
                :wrapperCol="{span: 20}"
              >{{seeinfo.gzms}}</a-form-item>
              <a-form-item label="故障图片" :labelCol="{span: 4}" :wrapperCol="{span: 20}">
                <img
                  class="gztp"
                  v-for="(imglist,index) in seeinfo.fileList"
                  :key="index"
                  :src="imglist.fileFullName"
                >
              </a-form-item>
              <a-form-item class="updatimg" :labelCol="{span: 4}" :wrapperCol="{span: 20}">
                <div style="text-align:right" slot="label">
                  维修时间<br>特殊要求
                </div>
                <span v-if="seeinfo.kssj && seeinfo.kssj !== ''">{{seeinfo.kssj}}--{{seeinfo.jssj}}</span>
              </a-form-item>
            </a-form>
            <div class="mydiyfooter">
              <a-button @click="handleSubmitsee" type="primary">确定</a-button>
            </div>
          </a-modal>
          <!-- 查看流程弹框 -->
          <a-modal
            class="lcmodal"
            destroyOnClose
            :maskClosable="false"
            :title="`报修单明细`"
            v-model="visibleprease"
            style="text-aling:left"
            :footer="null"
          >
            <p>
              报修单号：{{preaseData.bxdh}}
              <span>{{preaseData.dqztMc === '已废单'?'已取消':preaseData.dqztMc}}</span>
            </p>
            <div v-for="(preaseData,index) in preaseData.list" :key="index">
              <p>{{index+1}} {{preaseData.clms}}</p>
              {{preaseData.sj}}
            </div>
            <a-form v-if="preaseData.yqsmList && preaseData.yqsmList.length > 0">
            <a-form-item label="延单说明" :labelCol="{span: 4}" :wrapperCol="{span: 20}">
              <div style="line-height:1.5" v-for="(prease,ind) in preaseData.yqsmList" :key="ind">
                <p>{{prease.bz}}</p>
              </div>
            </a-form-item>
            </a-form>
            <div class="mydiyfooter">
              <a-button @click="handleSubmitprease" type="primary">确定</a-button>
            </div>
          </a-modal>
          <!-- 确认并评价弹框 -->
          <a-modal
            destroyOnClose
            :maskClosable="false"
            :title="`确认并评价`"
            v-model="visible"
            @ok="handleSubmitsure"
          >
            <a-form :form="formsure">
              <a-form-item label="完成情况" :labelCol="{span: 5}" :wrapperCol="{span: 18}">
                <div class="table-operators">
                  <a-button
                    :class="{'a-button-selected':complete==='1'}"
                    @click="finish"
                    style="margin-right:20px"
                  >已完成</a-button>
                  <a-button :class="{'a-button-selected':complete==='0'}" @click="unfinish">未完成</a-button>
                </div>
              </a-form-item>
              <a-form-item
                v-if="serviceModel"
                label="服务评价"
                :labelCol="{span: 5}"
                :wrapperCol="{span: 18}"
              >
                <a-radio-group @change="onxbChange" name="radioGroup" :defaultValue="xbradio">
                  <a-radio value="1">非常满意</a-radio>
                  <a-radio value="2">满意</a-radio>
                  <a-radio value="3">一般</a-radio>
                  <a-radio value="4">不满意</a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item label="意见反馈" :labelCol="{span: 5}" :wrapperCol="{span: 18}">
                <a-textarea
                  v-decorator="[
                        'yjfk',
                        {
                          rules:[
                            { required: false,message: '反馈意见不能为空！'}
                          ]
                        }
                      ]"
                  placeholder="请写下您的反馈意见"
                  maxlength="50"
                />
              </a-form-item>
            </a-form>
          </a-modal>
        </div>
      </slot>
    </a-layout-content>
    <!-- footer -->
    <a-layout-footer style="padding: 0px">
      <global-footer/>
    </a-layout-footer>
  </a-layout>
</template>

<script>
import GlobalHeader from '../../layouts/GlobalHeader'
import GlobalFooter from '../../layouts/GlobalFooter'
import PageHeader from '../../components/page/PageHeader'
import unget from '../../assets/png/unget.png'
import dealing from '../../assets/png/dealing.png'
import unsure from '../../assets/png/unsure.png'
import finish from '../../assets/png/finish.png'
import examine from '../../assets/png/examine.png'
import broken from '../../assets/png/broken.png'
import todeal from '../../assets/png/todeal.png'
import inclu from '../../assets/png/inclu.png'
import delayed from '../../assets/png/delayed.png'
import hasclan from '../../assets/png/hasclan.png'
import './Apply.less'
// const statusMap = ['启用', '停用'] // 0-启用、1-启用
export default {
  name: 'Apply',
  components: {
    GlobalHeader,
    GlobalFooter,
    PageHeader
  },
  computed: {
    linkList () {
      return this.$store.state.setting.footerLinks
    }
  },
  data () {
    const columns = [
      {
        title: '序号',
        dataIndex: '_index'
      },
      {
        title: '状态',
        align: 'center',
        width:100,
        customRender: (text, record) => {
          let displayText = {}
          if (text.dqzt === '1') {
            displayText.pointsrc = unget
          } else if (text.dqzt === '2') {
            displayText.pointsrc = dealing
          } else if (text.dqzt === '3') {
            displayText.pointsrc = unsure
          } else if (text.dqzt === '4') {
            displayText.pointsrc = finish
          } else if (text.dqzt === '5') {
            displayText.pointsrc = hasclan
          } else if (text.dqzt === '6') {
            displayText.pointsrc = examine
          } else if (text.dqzt === '7') {
            displayText.pointsrc = broken
          } else if (text.dqzt === '9') {
            displayText.pointsrc = todeal
          } else if (text.dqzt === '10') {
            displayText.pointsrc = inclu
          }
          var html = (<div class="alink"><img src={displayText.pointsrc} /><a href="javascript:" onClick={() => this.handleprocedure(true, record, 1)}>{record.dqztMc}</a></div>)
          if (text.yqbz === '0') {
            // 已延单 加延单标识
            html = (<div class="alink"><img src={displayText.pointsrc} /><a href="javascript:" onClick={() => this.handleprocedure(true, record, 2)}>{record.dqztMc}</a><img class="delayed" src={delayed} /></div>)
          }
          return html
        }
      },
      {
        title: '报修单号',
        dataIndex: 'bxdh',
        align: 'center'
      },
      {
        title: '报修时间',
        dataIndex: 'bxsj',
        align: 'center'
      },
      {
        title: '报修地点',
        dataIndex: 'bxdd',
        align: 'center'
      },
      {
        title: '报修类型',
        dataIndex: 'bxlx',
        align: 'center'
      },
      {
        title: '故障描述',
        dataIndex: 'gzms',
        align: 'center'
      },
      {
        title: '维修员',
        align: 'center',
        customRender: (text, record, index) => {
          var html = (
            <div class="row-operator">
              {' '}
              {record.wxyXm}
              <br />
              {record.wxySjh}{' '}
            </div>
          )
          return html
        }
      },
      {
        title: '操作',
        align: 'center',
        width: 200,
        customRender: (text, record, index) => {
          var html
          if (record.dqzt === '1') {
            if (record.cjwc !== '' && record.cjwc === '1') {
              html = (
                <div class="row-operator">
                  <a
                    href="javascript:;"
                    onClick={() => this.showModalSee(true, record)}
                  >
                    查看
                  </a>
                  <a-divider type="vertical" />
                </div>
              )
            } else {
              html = (
                <div class="row-operator">
                  <a
                    href="javascript:;"
                    onClick={() => this.showModalSee(true, record)}
                  >
                    查看
                  </a>
                  <a-divider type="vertical" />
                  <a
                    href="javascript:;"
                    onClick={() => this.handleCanel(record)}
                  >
                    {' '}
                    取消
                  </a>
                </div>
              )
            }
          } else if (
            record.dqzt === '2' ||
            record.dqzt === '4' ||
            record.dqzt === '7'
          ) {
            html = (
              <div class="row-operator">
                <a
                  href="javascript:;"
                  onClick={() => this.showModalSee(true, record)}
                >
                  查看
                </a>
              </div>
            )
          } else if (record.dqzt === '3') {
            html = (
              <div class="row-operator">
                <a
                  href="javascript:;"
                  onClick={() => this.showModalSee(true, record)}
                >
                  查看
                </a>
                <a-divider type="vertical" />
                <a href="javascript:;"onClick={() => this.showModal(true, record)}>
                  确认并评价
                </a>
              </div>
            )
          } else if (record.dqzt === '5') {
            html = (
              <div class="row-operator">
                <a
                  href="javascript:;"
                  onClick={() => this.showModalSee(true, record)}
                >
                  查看
                </a>
                <a-divider type="vertical" />
                <a
                  href="javascript:;"
                  onClick={() => this.handleRemove(record)}
                >
                  删除
                </a>
              </div>
            )
          }
          return html
        }
      }
    ]
    return {
      bxtype: this.$route.query.bxtype,
      breadcrumb: [],
      formsure: this.$form.createForm(this),
      columns,
      dataSource: [],
      selectedRows: [],
      visible: false,
      current: {},
      qyfjh: [{}],
      bxtitle: '报修须知',
      serviceModel: true,
      // 上传
      previewVisible: false,
      previewImage: '',
      fileList: [],
      // 须知
      shoudkonw: false,
      ny: '',
      // 查看
      seeinfo: {},
      visibleSee: false,
      visibleprease: false,
      preaseData: {},
      // 评价
      xbradio: '',
      // 已完成
      complete: ''
    }
  },
  mounted () {
    // 我的报修
    this.myorderList()
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb () {
      this.breadcrumb = this.$route.matched
    },
    // 我的报修表格
    myorderList () {
      this.$axios.post('/api/bxjl/getWdbxList.do').then(res => {
        this.dataSource = res.data.data || []
      })
    },

    onRowChange (selectedRows) {
      // console.log(selectedRows)
      this.selectedRows = selectedRows
    },
    // 切换数据
    onChange (changeParams) {
      this.myorderList()
    },

    /**
     * 获取请求列表参数
     * @param { Object } customParam 自定义处理
     * @return { Object } 请求列表参数
     */
    getFetchParams (customParam) {
      const { pageNum, isRemove } = customParam || {}
      let params = {
        // ...this.searchForm.getFieldsValue(),
        ...this.PAGINATION,
        ...customParam
      }
      if (pageNum && params.pageNum) {
        params.pageNum = pageNum
      } else {
        params.pageNum = 1
        params.pageSize = 10
      }
      if (isRemove && params.pageNum && this.dataSource.length % 10 === 1) {
        params.pageNum = params.pageNum > 2 ? params.pageNum - 1 : 1
      }
      // // 用户类型
      // params.type = '0'
      return params
    },
    // 显示确认评价弹框
    showModal (visible, record) {
      this.visible = !!visible
      this.current = record || {}
      this.xbradio = ''
      this.complete = ''
      // 编辑
      // if (record) {
      //   this.$nextTick(() => {
      //     let fields = this.form.getFieldsValue()
      //     for (var key in fields) {
      //       fields[key] = record[key]
      //     }
      //     this.form.setFieldsValue(fields)
      //   })
      // }
    },
    // 已完成
    finish () {
      this.serviceModel = true
      this.complete = '1'
    },
    // 未完成
    unfinish () {
      this.serviceModel = false
      this.complete = '0'
    },
    // 满意度单选
    onxbChange (checkedValues) {
      this.xbradio = checkedValues.target.value
    },
    // 查看弹窗
    showModalSee (visible, record) {
      this.visibleSee = !!visible
      if (record) {
        this.seeinfo = record
      }
    },
    // 查看流程
    handleprocedure (visible, record, type) {
      this.visibleprease = !!visible
      this.$axios.post('/api/bxjl/getLctByBxdh.do', { bxdh: record.bxdh }).then(res => {
        this.preaseData = res.data.data || []
        this.preaseData.dqztMc = record.dqztMc
      })
      if (type === 2) {
        this.$axios.post('/api/bxjl/updateBxdById.do', { id: record.id,qtYqbz: 1 }).then(res => {
        })
      }
    },
    // 顶部tab
    callback (key) {
      // 我的报修
      let params = {}
      if(this.bxtype == '2') {
        params = {
          bxtype: this.bxtype
        }
      }
      this.$router.push({ path: '/apply', query: params })
    },
    // 导出
    exportExe () {
      var url = ''
      window.location.herf = url
    },
    // 是否启用请求
    enableAjax (params) {
      this.$axios.post('/api/user/updateUserStatus', params).then(res => {
        this.$message.success(
          `成功${params.status === 1 ? ' 停用' : '启用'}！`
        )
        // 重新获取列表数据
        this.fetchList(this.getFetchParams())
      })
    },
    // 流程确定
    handleSubmitprease () {
      this.visibleprease = false
      this.myorderList()
    },
    // 查看确定
    handleSubmitsee () {
      this.visibleSee = false
    },
    // 确认并评价确定
    handleSubmitsure () {
      this.formsure.validateFields((err, values) => {
        if (!err) {
          // 处理编辑时添加ID字段
          if (JSON.stringify(this.current) !== '{}') {
            values.id = this.current.id
            values.bxdh = this.current.bxdh
          }
          values.fwpj = this.xbradio
          // values.yjfk = this.yjfk
          values.wcqk = this.complete
          if (values.wcqk === '' || values.wcqk === null) {
            this.$message.error(`请选择完成情况`)
            return false
          }
          // 已完成
          if ((values.wcqk !== '' || values.wcqk !== null) && values.wcqk === '1') {
            if (values.fwpj === '' || values.fwpj === null) {
              this.$message.error(`服务评价不能为空`)
              return false
            }
          } else if((values.wcqk !== '' || values.wcqk !== null) && values.wcqk === '0') {
            // 未完成
            if (!values.yjfk  || values.yjfk === '') {
              this.$message.error(`意见反馈不能为空`)
              return false
            }
          }
          // 接口请求
          this.submitAjax(values)
        }
      })
    },
    // 确认并评价请求
    submitAjax (params) {
      this.$axios.post('/api/bxjl/updateBxdById.do', params).then(res => {
        this.$message.success(`确认并评价成功`)
        this.myorderList()
        this.visible = false
      })
    },
    // 删除
    handleRemove (record) {
      this.$confirm({
        title: '提示',
        content: '您是否要进行该操作？',
        okType: 'danger',
        onOk: () => {
          // 删除请求
          this.removeAjax({ id: record.id })
        }
      })
    },
    // 删除请求
    removeAjax (params) {
      this.$axios.post('/api/bxjl/updateBxdById.do', params).then(res => {
        this.$message.success(`删除成功！`)
        this.myorderList()
      })
    },
    // 取消
    handleCanel (record) {
      this.$confirm({
        title: '提示',
        content: '您是否要进行该操作？',
        okType: 'danger',
        onOk: () => {
          // 删除请求
          var params = {
            bxdh: record.bxdh,
            cz: '8',
            sm: '',
            wxry: record.wxyDlm
          }
          this.CanelAjax(params)
        }
      })
    },
    // 取消请求
    CanelAjax (params) {
      this.$axios.post('/api/bxgl/addLcbz.do', params).then(res => {
        this.$message.success(`取消成功！`)
        this.myorderList()
      })
    }
  }
}
</script>
<style>
.lcmodal div {
  color: #999;
}
.lcmodal p {
  text-indent: 0;
  color: #333;
  margin-top: 8px;
}
.lcpicdiv img {
  width: 16%;
  height: 55px;
  margin-right: 2%;
  padding: 1%;
  border: 1px solid #e5e5e5;
}
.lcpicdiv :last-child {
  margin-right: 0;
}
.table-operator .alink img {
    margin-right: 3px;
    vertical-align: top;
    margin-top: 8px;
    border: none;
}
.updatimg .ant-form-item-label div {
  margin-top: -10px;
}
</style>
